export enum SERVICE_PLAN_ITEMS_METRICS {
    SEATS = 'seats',
    UNIT = 'unit',
    API_CALLS = 'api_calls',
    GB = 'gb',
    CALLS = 'calls',
    DEVICES = 'devices',
}

export type ServicePlanItem = {
    id: string;
    created_at: string;
    modified_at: string;
    name: string;
    code: string;
    is_required: boolean;
    metric: SERVICE_PLAN_ITEMS_METRICS | null;
    external_item_id: number | null;
    is_active: boolean | null;
    service_plan: string;
    starting_quantity: number | null;
};
